import config from '@/config/prod.env';
import header from '@/helper/header';
import common from '@/helper/common';
import pbiService from '@/services/pbi.service';

import { store } from "@/store";
import userService from '@/services/user.service';

export const authenticationService = {
    //changePassword,
    logout,
    register,
    //changePersonal
    getLoginInfoFromSSO
};

async function logout() {
    // xoá user từ local storage để log out
   localStorage.removeItem('login_info');
   localStorage.removeItem('user_profile');
}

async function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return await fetch(`${process.env.VUE_APP_API_URL}/user/register`, requestOptions).then(response => common.handleResponse(response));
}

async function getLoginInfoFromSSO(loginId) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderNoToken(),
        body: JSON.stringify({ 
          "loginInfoId": loginId,
          "appId": process.env.VUE_APP_ID
        })
      };

    let res = await fetch(`https://ioc-sdc-administration-api.vnptdongthap.com.vn/api/v1/Auth/GetLoginInfo`, requestOptions);
    let rs = await common.handleResponse(res);

    if(rs.isOk) {
        let data = rs.data;
        if (data.data) {
            // lấy Power BI token
            let pbiAccessTokenRes = await pbiService.getAccessToken(data.data.accessToken);
            if(pbiAccessTokenRes.isOk && pbiAccessTokenRes.data.data) {
                data.data.pbiAccessToken = pbiAccessTokenRes.data.data;
            }

            // lưu dữ liệu user và token jwt vào local storage để giữ user được log in trong page
            localStorage.setItem('login_info', JSON.stringify(data.data));

            // lấy thông tin user
            let userProfile = await userService.getProfile(data.data.userInfo.userId);
            localStorage.setItem('user_profile', JSON.stringify(userProfile.data.data[0]));
            return data.data;
        } else {
            return data.message;
        }
    }
    return 'Có lỗi xảy ra - vui lòng thử lại';
}